module.exports = __webpack_public_path__ + "img/coinbankB11.bc3a8374.jpg";